/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { HttpClient, RequestParams } from "./http-client";

@Injectable()
export class MixpanelproxyClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags MixpanelProxy
   * @name MixpanelProxyPost
   * @summary Submits a Mixpanel Track event.
   * @request POST:/mixpanelproxy/track
   */
  mixpanelProxyPost = (
    query?: {
      /**
       * The Mixpanel verbose query parameter
       * @format int32
       * @default 0
       */
      verbose?: number;
      /**
       * The Mixpanel debug query parameter
       * @format int32
       * @default 0
       */
      debug?: number;
      /**
       * The Mixpanel ip query parameter
       * @format int32
       * @default 0
       */
      ip?: number;
      /** The Mixpanel timestamp query parameter */
      _?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<string, any>({
      path: `/mixpanelproxy/track`,
      method: "POST",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MixpanelProxy
   * @name MixpanelProxyPost2
   * @summary Submits a Mixpanel Track event.
   * @request POST:/mixpanelproxy/import
   */
  mixpanelProxyPost2 = (
    query?: {
      /**
       * The Mixpanel verbose query parameter
       * @format int32
       * @default 0
       */
      verbose?: number;
      /**
       * The Mixpanel debug query parameter
       * @format int32
       * @default 0
       */
      debug?: number;
      /**
       * The Mixpanel ip query parameter
       * @format int32
       * @default 0
       */
      ip?: number;
      /** The Mixpanel timestamp query parameter */
      _?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<string, any>({
      path: `/mixpanelproxy/import`,
      method: "POST",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MixpanelProxy
   * @name MixpanelProxyPost3
   * @summary Submits a Mixpanel Track event.
   * @request POST:/mixpanelproxy/engage
   */
  mixpanelProxyPost3 = (
    query?: {
      /**
       * The Mixpanel verbose query parameter
       * @format int32
       * @default 0
       */
      verbose?: number;
      /**
       * The Mixpanel debug query parameter
       * @format int32
       * @default 0
       */
      debug?: number;
      /**
       * The Mixpanel ip query parameter
       * @format int32
       * @default 0
       */
      ip?: number;
      /** The Mixpanel timestamp query parameter */
      _?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<string, any>({
      path: `/mixpanelproxy/engage`,
      method: "POST",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags MixpanelProxy
   * @name MixpanelProxyPost4
   * @summary Submits a Mixpanel Track event.
   * @request POST:/mixpanelproxy/groups
   */
  mixpanelProxyPost4 = (
    query?: {
      /**
       * The Mixpanel verbose query parameter
       * @format int32
       * @default 0
       */
      verbose?: number;
      /**
       * The Mixpanel debug query parameter
       * @format int32
       * @default 0
       */
      debug?: number;
      /**
       * The Mixpanel ip query parameter
       * @format int32
       * @default 0
       */
      ip?: number;
      /** The Mixpanel timestamp query parameter */
      _?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<string, any>({
      path: `/mixpanelproxy/groups`,
      method: "POST",
      query: query,
      format: "json",
      ...params,
    });
}
